// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"71495bc9","787":"28cb0dcd","991":"19bc3f02"}[chunkId] + ".chunk.js";
};